module.exports = __webpack_public_path__ + "img/c500.46cbf2a7.jpg";